import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// =====================================================================
// LEGAL LAYOUT — shared shell for /privacy, /cookie-policy, /terms.
// Renders a language toggle (IT default, EN secondary) and exposes
// the active language to the page via the render-prop pattern.
// =====================================================================
export default function LegalLayout({ title, sub, render, defaultLang = "it" }) {
  const [lang, setLang] = React.useState(defaultLang);
  return (
    <div className="min-h-screen bg-[#09090B] text-white">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <Link
          to="/"
          data-testid="legal-back-home"
          className="inline-flex items-center gap-2 text-zinc-500 hover:text-white mb-8 font-mono text-xs uppercase tracking-widest"
        >
          <ArrowLeft className="w-4 h-4" /> Home
        </Link>

        <div className="flex items-start justify-between gap-4 mb-3">
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#FF4400]">
            · {sub}
          </div>
          <div className="flex items-center gap-1 bg-zinc-900 border border-zinc-800 rounded-sm p-1">
            <button
              onClick={() => setLang("it")}
              data-testid="legal-lang-it"
              className={`px-2.5 py-1 text-[10px] font-mono uppercase tracking-widest rounded-sm transition-colors ${
                lang === "it" ? "bg-[#FF4400] text-white" : "text-zinc-400 hover:text-white"
              }`}
            >
              IT
            </button>
            <button
              onClick={() => setLang("en")}
              data-testid="legal-lang-en"
              className={`px-2.5 py-1 text-[10px] font-mono uppercase tracking-widest rounded-sm transition-colors ${
                lang === "en" ? "bg-[#FF4400] text-white" : "text-zinc-400 hover:text-white"
              }`}
            >
              EN
            </button>
          </div>
        </div>

        <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter mb-10">{title}</h1>

        <article
          className="prose prose-invert max-w-none font-body text-zinc-300 leading-relaxed [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-black [&_h2]:tracking-tight [&_h2]:text-white [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:font-display [&_h3]:text-lg [&_h3]:font-bold [&_h3]:text-white [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:my-3 [&_ul]:my-3 [&_ul]:pl-6 [&_ul]:list-disc [&_li]:my-1 [&_strong]:text-white [&_a]:text-[#FF4400] [&_a:hover]:text-[#FF6633] [&_table]:w-full [&_table]:text-sm [&_table]:my-4 [&_th]:text-left [&_th]:py-2 [&_th]:pr-4 [&_th]:font-mono [&_th]:text-[10px] [&_th]:uppercase [&_th]:tracking-widest [&_th]:text-zinc-500 [&_th]:border-b [&_th]:border-zinc-800 [&_td]:py-2 [&_td]:pr-4 [&_td]:border-b [&_td]:border-zinc-900 [&_td]:text-[13px]"
        >
          {render(lang)}
        </article>

        <p className="mt-12 text-[12px] font-body text-zinc-500">
          {lang === "it"
            ? "Ultimo aggiornamento: 2 giugno 2026 · Versione 1.0"
            : "Last updated: June 2, 2026 · Version 1.0"}
        </p>
      </div>
    </div>
  );
}
